import { advanceTask } from './advanceTask'
import { IJob, registerJob } from './jobs'
import { createConsumeCargoTask } from './taskConsumeCargo'
import { createTask_custom } from './taskCustom'
import { createTask_deliverCargo } from './taskDeliverCargo'
import { createFetchCargoTask } from './taskFetchCargo'
import { jobLogger } from './jobLogger-sidecar'

export const register = () => registerJob('melt-ice', advanceJob_meltIce)

export function advanceJob_meltIce(job: IJob) {
  jobLogger.assertJobType(job, 'melt-ice')

  let mc = jobLogger.assertMachine(job, (c) => c.data.type === 'ice-melter')

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []
    let task = createFetchCargoTask(mc.i, mc.j, null, 'ice', true)
    job.tasks.push(task)

    task = createTask_deliverCargo(mc.i, mc.j, 'ice', true)
    job.tasks.push(task)

    task = createConsumeCargoTask(mc.i, mc.j, 'ice')
    job.tasks.push(task)

    task = createTask_custom(mc.i, mc.j, () => {
      mc.waterSupply = 100
      task.isComplete = true
    })
    job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
